import React from 'react'
import Rugs from '../../components/rugs/index';

const RugPage = () => {
    return (
        <div>
            <Rugs />
        </div>
    )
}

export default RugPage